import { Component, ReactNode } from "react"

import moment from "moment"

import { BaseEnumType } from "../../libs/initialization/remoteInits"

import Select from "../../libs/ui/inputs/Select"

const BASE_MONTHS : BaseEnumType[] = [
    {id: "1", value: "Gennaio"},
    {id: "2", value: "Febbraio"},
    {id: "3", value: "Marzo"},
    {id: "4", value: "Aprile"},
    {id: "5", value: "Maggio"},
    {id: "6", value: "Giugno"},
    {id: "7", value: "Luglio"},
    {id: "8", value: "Agosto"},
    {id: "9", value: "Settembre"},
    {id: "10", value: "Ottobre"},
    {id: "11", value: "Novembre"},
    {id: "12", value: "Dicembre"}
]

interface MonthProps {
    id: string 
    label: string

    value : number | undefined
    valueError : string | undefined

    cutOffYear : number | undefined
    showOnlyInfuture?: boolean | undefined  // se presente indica che il mese deve essere nel presente / futuro

    regexp: Function
    callBack: Function
}

interface MonthState {
    monthsToDisplay: BaseEnumType[]
    error: string | undefined
}

class Month extends Component<MonthProps, MonthState> {
    constructor (props: any) {
        super (props)

        this.state = {
            monthsToDisplay: this.getMonthsToShow( this.props.cutOffYear ),
            error: undefined
        }

        this.update = this.update.bind(this)
        this.validate = this.validate.bind(this)
    }

    componentDidUpdate(prevProps: Readonly<MonthProps>, prevState: Readonly<MonthState>, snapshot?: any): void {
        if (
            this.props.cutOffYear !== undefined && prevProps.cutOffYear !== this.props.cutOffYear // ho un anno limite
        ) {
            const next = this.getMonthsToShow( this.props.cutOffYear )

            if (!this.uqeauls(next, this.state.monthsToDisplay)) {
                this.setState({
                    monthsToDisplay: next
                })
            }
        }
    }

    render (): ReactNode {
        const error = this.props.valueError ?? this.validate (this.props.value)

        return (
            <Select
                id={this.props.id} name={this.props.id} key={this.props.id}
                label={this.props.label} 
                value={this.props.value?.toString()}
                options={ this.state.monthsToDisplay }
                callback={this.update}
                error={error}
                forceSortById={true}
            />
        )
    }

    private update (val: any) {
        this.setState({
            error: this.validate (val)
        }, () => {
            this.props.callBack (val)
        })
    }

    private validate (val: any) {
        return ( !this.props.regexp( val ) )
            ? 'Valore non valido'
            : undefined
    }

    private getMonthsToShow (cutOff : number | undefined) {
        if (cutOff !== undefined) {
            const currentYear = Number( moment().year() )
            const currentMonth = Number( moment().month() )

            if (currentYear === Number(cutOff)) {
                // se li voglio nel futuro saranno tutti i mesi >= mese corrente
                // altrimenti tutti i mesi <= mese corrente
                return (this.props.showOnlyInfuture === true)
                    ? BASE_MONTHS.filter ( (m: BaseEnumType) => Number( m.id ) >= currentMonth )
                    : BASE_MONTHS.filter ( (m: BaseEnumType) => Number( m.id ) <= currentMonth )
            }
        }

        return BASE_MONTHS
    }

    private uqeauls ( a: BaseEnumType[], b: BaseEnumType[] ) {
        return a.length === b.length && a.every((val, index) => val === b[index]);
    }

}

export default Month